import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';

const STORAGE_KEY = 'bb_date_format';
const DEFAULT_FORMAT = 'dd/MM/yyyy';
const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const DATE_FORMAT_OPTIONS = [
  { value: 'dd/MM/yyyy',   label: 'dd/mm/yyyy',   example: '18/06/2026' },
  { value: 'dd-MMM-yyyy',  label: 'dd-mmm-yyyy',  example: '18-Jun-2026' },
  { value: 'dd/MM/yy',     label: 'dd/mm/yy',     example: '18/06/26' },
  { value: 'dd-MMM-yy',    label: 'dd-mmm-yy',    example: '18-Jun-26' },
];

@Injectable({ providedIn: 'root' })
export class DateFormatService {
  private _current: string;

  constructor(private http: HttpClient, private config: ConfigurationService) {
    this._current = localStorage.getItem(STORAGE_KEY) || DEFAULT_FORMAT;
    this._loadFromApi();
  }

  get current(): string { return this._current; }

  setFormat(fmt: string): void {
    this._current = fmt;
    localStorage.setItem(STORAGE_KEY, fmt);
  }

  refreshFromApi(): void { this._loadFromApi(); }

  format(value: string | Date | null | undefined): string {
    if (!value) return '';
    const d = value instanceof Date ? value : new Date(value as string);
    if (isNaN(d.getTime())) return '';
    return this._applyFormat(d, this._current);
  }

  private _applyFormat(d: Date, fmt: string): string {
    const dd   = String(d.getDate()).padStart(2, '0');
    const MM   = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const yy   = String(yyyy).slice(-2);
    const MMM  = MONTH_NAMES[d.getMonth()];
    if (fmt === 'dd/MM/yyyy')  return `${dd}/${MM}/${yyyy}`;
    if (fmt === 'dd/MM/yy')    return `${dd}/${MM}/${yy}`;
    if (fmt === 'dd-MMM-yy')   return `${dd}-${MMM}-${yy}`;
    return `${dd}-${MMM}-${yyyy}`;
  }

  private _loadFromApi(): void {
    this.http.get<any>(
      `${this.config.apiBaseUrl}/sysParam/getDateFormat`,
      { params: new HttpParams().set('criteria', '{}') }
    ).subscribe({
      next: (res) => {
        const fmt = res?.Data?.dateFormat;
        if (fmt) this.setFormat(fmt);
      },
      error: () => {},
    });
  }
}
